import { render } from "./OfferingList.vue?vue&type=template&id=f5d4ab04&scoped=true"
import script from "./OfferingList.vue?vue&type=script&lang=js"
export * from "./OfferingList.vue?vue&type=script&lang=js"

import "./OfferingList.vue?vue&type=style&index=0&id=f5d4ab04&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5d4ab04"]])

export default __exports__